import { useAuth } from 'context/AuthContext';
import { SidebarTabsProps } from 'interfaces/components/SidebarTabs';

const SidebarTabs = ({
  handleToggle,
  selectedSidebarTab
}: SidebarTabsProps) => {
  const { isPortCo } = useAuth();

  if (isPortCo) return <p className='text-gray-700'>Benchmark Categories</p>;

  return (
    <div className='flex items-center h-8 border border-gray-300 rounded-lg cursor-pointer overflow-hidden'>
      <div
        className={`px-3 py-0.5 text-gray-700 ${
          selectedSidebarTab === 0 ? 'font-semibold' : 'font-light'
        }`}
        onClick={() => handleToggle(0)}
      >
        Charts
      </div>
      <div
        className={`px-3 py-1 text-white whitespace-nowrap  duration-200 ease-linear ${
          selectedSidebarTab === 0
            ? 'bg-purple-700/60 font-light'
            : 'bg-purple-700 font-semibold'
        }`}
        onClick={() => handleToggle(1)}
      >
        Your Data
      </div>
    </div>
  );
};

export default SidebarTabs;
